import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-main" },
    [
      _c(
        "div",
        { staticClass: "reporting-header d-flex align-center mb-2" },
        [
          _c(
            VBtn,
            {
              staticClass: "reporting-back-btn",
              attrs: { text: "", small: "" },
              on: { click: _vm.backToConfig },
            },
            [
              _c(VIcon, { attrs: { left: "" } }, [_vm._v("arrow_back")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("reporting.config.reportingConfiguration")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("attribute-filter-panel", {
        staticClass: "attribute-filter-panel",
        attrs: {
          "filter-rules": _vm.reportingAttributesFilter,
          "use-reporting-store": true,
          "enable-hierarchy-filters": "",
          "title-localisation": "attributes.filters.filterByAttributes",
          "filter-count-localisation": "attributes.filters.numApplied",
        },
        on: { attributeFilterChange: _vm.setReportingFilter },
      }),
      _vm._v(" "),
      _c("reporting-grid"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }